import { Link } from 'react-router-dom';
import { BlogPost } from '@/lib/supabase';
import { Calendar, Clock, ArrowRight } from 'lucide-react';

interface BlogCardProps {
  post: BlogPost;
}

export function BlogCard({ post }: BlogCardProps) {
  // Calcular tiempo de lectura estimado (200 palabras por minuto)
  const wordCount = post.content ? post.content.replace(/<[^>]*>?/gm, '').length / 5 : 0;
  const readTime = Math.ceil(wordCount / 200);

  return (
    <Link to={`/blog/${post.slug}`} className="group flex flex-col bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-lg transition-all duration-300 h-full">
      <div className="aspect-[16/9] overflow-hidden bg-slate-100 relative">
        {post.image_url ? (
          <img 
            src={post.image_url} 
            alt={post.title} 
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-slate-100 text-slate-300">
            <span className="text-sm font-medium">Sin imagen</span>
          </div>
        )}
        
        {post.categories && (
          <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-blue-600 uppercase tracking-wide shadow-sm">
            {post.categories.name}
          </div>
        )}
      </div>

      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center gap-4 text-xs text-slate-500 mb-3">
          <div className="flex items-center gap-1">
            <Calendar className="w-3.5 h-3.5" />
            {new Date(post.published_at || post.created_at).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
          </div>
          <div className="flex items-center gap-1">
            <Clock className="w-3.5 h-3.5" />
            {readTime} min lectura
          </div>
        </div>

        <h3 className="text-xl font-bold text-slate-900 mb-3 line-clamp-2 group-hover:text-blue-600 transition-colors">
          {post.title}
        </h3>

        <p className="text-slate-600 text-sm line-clamp-3 mb-6 flex-1">
          {post.excerpt}
        </p>

        <div className="flex items-center text-blue-600 font-bold text-sm group-hover:translate-x-1 transition-transform">
          Leer artículo <ArrowRight className="w-4 h-4 ml-1" />
        </div>
      </div>
    </Link>
  );
}
